import { createContext, useContext } from 'react';

import type { QuestionsReporData } from '../types';

export const ReportContext = createContext<QuestionsReporData>({
  header: {} as QuestionsReporData['header'],
  body: {} as QuestionsReporData['body'],
  values: {},
});

export const useReport = () => {
  const context = useContext(ReportContext);

  if (!context) {
    throw new Error('useReport must be used within a ReportProvider');
  }

  return context;
};
